import {
  USE_NEXT_BROWSE_EXPERIMENT_NAME,
  USE_NEXT_HOMEPAGE_EXPERIMENT_NAME,
  USE_NEXT_COLLECTIONS_EXPERIMENT_NAME,
  USE_NEXT_PDP_EXPERIMENT_NAME,
} from '@/constants/global';

// list of URLs that should be opened via a full refresh (don't use Nuxt/SPA)
const URL_WHITELIST_PREFIX = [
  '/collections/alternative-to/',
  '/asksumo/',
];

export default async ({ app, store }) => {
  const whitelistPrefix = [...URL_WHITELIST_PREFIX];
  const whitelistExact = [];

  await store.dispatch('experiments/enrollByName', USE_NEXT_HOMEPAGE_EXPERIMENT_NAME);
  await store.dispatch('experiments/enrollByName', USE_NEXT_BROWSE_EXPERIMENT_NAME);
  await store.dispatch('experiments/enrollByName', USE_NEXT_COLLECTIONS_EXPERIMENT_NAME);
  await store.dispatch('experiments/enrollByName', USE_NEXT_PDP_EXPERIMENT_NAME);

  const getExperimentVariant = store.getters['experiments/getExperimentVariant'];
  const isNextBrowseEnabled = getExperimentVariant(USE_NEXT_BROWSE_EXPERIMENT_NAME) === 'enabled';
  const isNextHomeEnabled = getExperimentVariant(USE_NEXT_HOMEPAGE_EXPERIMENT_NAME) === 'enabled';
  const isNextCollectionsEnabled = getExperimentVariant(USE_NEXT_COLLECTIONS_EXPERIMENT_NAME) === 'enabled';
  const isNextPDPEnabled = getExperimentVariant(USE_NEXT_PDP_EXPERIMENT_NAME) === 'enabled';

  if (isNextBrowseEnabled) {
    whitelistPrefix.push('/browse/');
    whitelistPrefix.push('/search/');
    whitelistPrefix.push('/software/');
    whitelistPrefix.push('/creative-resources/');
    whitelistPrefix.push('/templates/');
    whitelistPrefix.push('/courses-learning/');
  }

  if (isNextCollectionsEnabled) {
    whitelistPrefix.push('/collections/');
  }

  if (isNextPDPEnabled) {
    whitelistPrefix.push('/products/');
  }

  if (isNextHomeEnabled) {
    whitelistExact.push('/');
  }

  // add beforeEach handler once we are ready to avoid infinite loop
  app.router.onReady(() => {
    app.router.beforeEach((to, from, next) => {
      if (whitelistExact.some((url) => to.path === url)
          || whitelistPrefix.some((url) => to.path.startsWith(url))) {
        window.location.href = to.path;
      } else {
        next();
      }
    });
  });
};
